import clx from 'classnames';
import { PROJECT_STEP_ACTIVE_BG_IMG, PROJECT_STEP_BG_IMG } from '@/constants';
import { ProjectTime } from '@/types/home';
import { useStepList } from './hook';
import { useFm } from '@web3/base-hooks';

import styles from './stepList.module.scss';

const StepList = ({ timeList }: { timeList: ProjectTime[] }) => {
  const { stepList, currentStep } = useStepList(timeList);
  const fm = useFm();

  return (
    <div className={styles.stepList}>
      {stepList?.map((item, index) => (
        <div
          key={index}
          className={clx([styles.step, index === currentStep && styles.active])}
          style={{
            backgroundImage:
              +index === currentStep
                ? `url(${PROJECT_STEP_ACTIVE_BG_IMG})`
                : `url(${PROJECT_STEP_BG_IMG})`,
          }}
        >
          <div className={styles.label}>{item.label}</div>
          <div className={styles.time}>
            {index === 0
              ? `${fm('utcFeb28ToMar13')}`
              : `${fm('utcMar14ToMar27_2025')}`}
          </div>
        </div>
      ))}
    </div>
  );
};

export default StepList;
